/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tall_Wide_Wasp_DartInputs */

const en_tall_wide_wasp_dart = /** @type {(inputs: Tall_Wide_Wasp_DartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage the user's personal information`)
};

const de_tall_wide_wasp_dart = /** @type {(inputs: Tall_Wide_Wasp_DartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwalten Sie die persönlichen Informationen des Benutzers`)
};

/**
* | output |
* | --- |
* | "Manage the user's personal information" |
*
* @param {Tall_Wide_Wasp_DartInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tall_wide_wasp_dart = /** @type {((inputs?: Tall_Wide_Wasp_DartInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tall_Wide_Wasp_DartInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tall_wide_wasp_dart(inputs)
	return de_tall_wide_wasp_dart(inputs)
});